import React, {Component} from "react";
import RouteURLs from 'RouteURLs';
import {RouteComponentProps} from 'react-router';
import {Button} from "@material-ui/core";
import Form, {FormStatus} from "components/forms/Form";
import TextField from "components/forms/TextField";
import {ValidationGroup, Validators} from 'util/validation';
import {requestPasswordReset} from 'services/auth';
import {logPageView} from 'services/analytics';
import ProgressSpinner from 'components/ProgressSpinner';
import AuthLayout from 'layouts/Authentication';
import './index.scss';
import {ValueError} from 'util/errors';

interface RequestPasswordResetPageState {
  status: FormStatus;
  error?: string;
}

interface ResetPasswordRequest {
  email: string;
}

export default class RequestPasswordResetPage extends Component<RouteComponentProps, RequestPasswordResetPageState> {
  private readonly validation: ValidationGroup;
  private readonly model: ResetPasswordRequest;

  state = {
    status: FormStatus.None,
    error: undefined
  };

  constructor(props: any) {
    super(props);
    this.model = { email: "" };
    this.validation = new ValidationGroup(this.model);
    this.validation.addField("email", {
      required: Validators.required
    });
  }

  componentDidMount(): void {
    logPageView(RouteURLs.REQUEST_PASSWORD_RESET, 'Request Password Reset');
  }

  onSubmit = () => {
    this.setState({ status: FormStatus.Submitting });
    requestPasswordReset(this.model.email).then(
      () => {
        this.setState({ status: FormStatus.Success });
      },
      err => {
        if (err instanceof ValueError) {
          for(const key of Object.keys(err.fieldErrors)) {
            for (const fieldError of err.fieldErrors[key]) {
              this.validation.addFieldError(key, fieldError);
            }
          }
          this.setState({
            status: FormStatus.Failure,
            error: err.errors ? err.errors[0] : undefined
          });
        } else {
          this.setState({
            status: FormStatus.Failure,
            error: "Unknown error."
          });
        }
      }
    );
  };

  onFieldInput = () => {
    this.setState({ status: FormStatus.None });
  };

  onLoginClick = () => {
    this.props.history.push(RouteURLs.LOGIN);
  };
    
  render() {
    const disabled = this.state.status === FormStatus.Submitting || this.state.status === FormStatus.Success;
    return <AuthLayout id="request-password-reset-page">
      { this.state.status !== FormStatus.Success &&
        <Form onSubmit={this.onSubmit} validationGroup={this.validation}>
          <h1>Forgot your password?</h1>
          <p>We'll help you reset it</p>
          <TextField
            name="email"
            label="Email"
            type="text"
            required={true}
            validationGroup={this.validation}
            model={this.model}
            validationMessages={{required: "Email is required"}}
            disabled={disabled}
            onInput={this.onFieldInput}/>
          <div className="actions">
            <Button className="submit" type="submit" disabled={disabled}>
              {this.state.status === FormStatus.Submitting && (
                <ProgressSpinner />
              )}
              Reset Password</Button>
          </div>
          {this.state.status === FormStatus.Failure && (
            <p className="error">{this.state.error}</p>
          )}
        </Form>
      }
      { this.state.status === FormStatus.Success &&
        <section className="success">
          <h1>Check your inbox</h1>
          <p>We've sent instructions to <span className="email">{ this.model.email }</span>.  You’ll be back up and running in no time.</p>
          <p>If you don't receive an email, please check your spam folder. Thanks!</p>
          <Button onClick={this.onLoginClick}>Back to log in</Button>
        </section>
      }
    </AuthLayout>;
  }
}
